import {PropertyBase} from "./PropertyBase";
import * as React from "react";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";
import {FontFamilyMark} from "InternalShared/PageBuilder/Controls/Properties/marks/FontFamilyMark/FontFamilyMark";

declare let rednaoPDFInvoiceParams:any;

export class TextProperty extends PropertyBase{
    public label:string='Text';
    private elementID:string;
    public Fields:any=[];

    public SetFields(field:any){
        this.Fields=field;
        return this;
    }



    public SubRenderer(): React.ReactNode {
        return(
            <SlateEditor Fields={this.Fields}  marks={[new FontFamilyMark()]} Label={this.label} Store={this.Options} PropertyName={this.OptionsPropertyName} onChange={e=>{this.toolItem.Refresh()}} />
        )
    }



}

